import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { db } from "./firebase";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter
} from "firebase/firestore";
import PageLayout from "./components/PageLayout";
import Username from "./components/Username";
import { isProUser } from "./utils/entitlements";

function Discover() {
  const [builds, setBuilds] = useState([]);
  const [searchParams] = useSearchParams();
  const initialSearch = searchParams.get("search") || "";
  const [search, setSearch] = useState(initialSearch);
  const [make, setMake] = useState("");

  const [lastDoc, setLastDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    loadBuilds(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadBuilds = async (initialLoad = false) => {
    if (loading) return;

    setLoading(true);

    try {
      const profilesRef = collection(db, "profiles");

      const profilesQuery =
        initialLoad || !lastDoc
          ? query(profilesRef, orderBy("usernameLowercase"), limit(15))
          : query(
              profilesRef,
              orderBy("usernameLowercase"),
              startAfter(lastDoc),
              limit(15)
            );

      const snapshot = await getDocs(profilesQuery);

      if (snapshot.empty) {
        setHasMore(false);
        setLoading(false);
        return;
      }

      const buildList = [];

      snapshot.forEach((docItem) => {
        const profile = docItem.data();

        if (profile.garageCars && profile.garageCars.length > 0) {
          profile.garageCars.forEach((car) => {
            buildList.push({
              ...car,
              ownerUsername: profile.username,
              ownerDisplayName: profile.displayName,
              ownerImage: profile.imageUrl,
              ownerIsPro: isProUser(profile)
            });
          });
        }
      });

      setBuilds((prevBuilds) =>
        initialLoad ? buildList : [...prevBuilds, ...buildList]
      );

      setLastDoc(snapshot.docs[snapshot.docs.length - 1]);

      if (snapshot.docs.length < 15) {
        setHasMore(false);
      }
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

const filteredBuilds = builds.filter((build) => {
  const searchText = search.trim().toLowerCase();

  const makeMatch =
    make === "" ||
    (build.make && build.make.toLowerCase() === make.toLowerCase());

  if (!searchText) {
    return makeMatch;
  }

  const usernameMatch =
    build.ownerUsername &&
    build.ownerUsername.toLowerCase().includes(searchText);

  const carNameMatch =
    build.name && build.name.toLowerCase().includes(searchText);

  const modMatch =
    build.mods &&
    build.mods.some(
      (mod) =>
        mod.partName?.toLowerCase().includes(searchText) ||
        mod.brand?.toLowerCase().includes(searchText)
    );

  return (usernameMatch || carNameMatch || modMatch) && makeMatch;
});

  const getMatchedMods = (build) => {
    if (!search.trim() || !build.mods) return [];

    const searchText = search.toLowerCase();

    return build.mods.filter(
      (mod) =>
        mod.partName?.toLowerCase().includes(searchText) ||
        mod.brand?.toLowerCase().includes(searchText)
    );
  };

  function StatusBadge({ status }) {
    let backgroundColor = "#2ecc71";

    if (status === "In Progress") {
      backgroundColor = "#f1c40f";
    }

    if (status === "Sold") {
      backgroundColor = "#ff6200";
    }

    if (status === "For Sale") {
      backgroundColor = "#fd0d05";
    }

    return (
      <span
        style={{
          backgroundColor,
          color: "white",
          padding: "8px 14px",
          borderRadius: "999px",
          fontSize: "11px",
          letterSpacing: "0.5px",
          textTransform: "uppercase",
          fontWeight: "bold",
          display: "inline-block",
          marginTop: "10px"
        }}
      >
        {status}
      </span>
    );
  }

  return (
<PageLayout
  title="Discover Builds"
  maxWidth="1100px"
>

        <input
          placeholder="Search username, car, part, or brand..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={inputStyle}
        />

        <select
          value={make}
          onChange={(e) => setMake(e.target.value)}
          style={inputStyle}
        >
          <option value="">All Makes</option>
          <option value="Acura">Acura</option>
          <option value="Alfa Romeo">Alfa Romeo</option>
          <option value="Aston Martin">Aston Martin</option>
          <option value="Audi">Audi</option>
          <option value="Bentley">Bentley</option>
          <option value="BMW">BMW</option>
          <option value="Bugatti">Bugatti</option>
          <option value="Cadillac">Cadillac</option>
          <option value="Chevrolet">Chevrolet</option>
          <option value="Dodge">Dodge</option>
          <option value="Ferrari">Ferrari</option>
          <option value="Ford">Ford</option>
          <option value="Genesis">Genesis</option>
          <option value="GMC">GMC</option>
          <option value="Honda">Honda</option>
          <option value="Hyundai">Hyundai</option>
          <option value="Infiniti">Infiniti</option>
          <option value="Jaguar">Jaguar</option>
          <option value="Jeep">Jeep</option>
          <option value="Kia">Kia</option>
          <option value="Koenigsegg">Koenigsegg</option>
          <option value="Lamborghini">Lamborghini</option>
          <option value="Land Rover">Land Rover</option>
          <option value="Lexus">Lexus</option>
          <option value="Lincoln">Lincoln</option>
          <option value="Lotus">Lotus</option>
          <option value="Lucid">Lucid</option>
          <option value="Maserati">Maserati</option>
          <option value="Mazda">Mazda</option>
          <option value="McLaren">McLaren</option>
          <option value="Mercedes-Benz">Mercedes-Benz</option>
          <option value="Mini">Mini</option>
          <option value="Mitsubishi">Mitsubishi</option>
          <option value="Nissan">Nissan</option>
          <option value="Pagani">Pagani</option>
          <option value="Polestar">Polestar</option>
          <option value="Porsche">Porsche</option>
          <option value="RAM">RAM</option>
          <option value="Rimac">Rimac</option>
          <option value="Rolls-Royce">Rolls-Royce</option>
          <option value="Subaru">Subaru</option>
          <option value="Suzuki">Suzuki</option>
          <option value="Tesla">Tesla</option>
          <option value="Toyota">Toyota</option>
          <option value="Volkswagen">Volkswagen</option>
          <option value="Volvo">Volvo</option>
          <option value="Other">Other</option>
        </select>

        <p style={{ opacity: 0.7 }}>{filteredBuilds.length} Builds Found</p>

        <div style={gridStyle}>
          {filteredBuilds.map((build) => (
            <Link
              key={`${build.ownerUsername}-${build.id}`}
              to={`/user/${build.ownerUsername}/car/${build.id}`}
              style={cardLinkStyle}
            >
              <div style={cardStyle}>
                {build.images && build.images.length > 0 ? (
                  <img
                    src={build.images[0]}
                    alt={build.name}
                    loading="lazy"
                    style={carImageStyle}
                  />
                ) : (
                  <div style={placeholderImageStyle}>No Photo</div>
                )}

                <div style={cardContentStyle}>
                  <h2 style={titleStyle}>{build.name}</h2>

                  <p style={{ opacity: 0.7, color: "#aaa", fontWeight: "bold" }}><Username username={build.ownerUsername} isPro={build.ownerIsPro} /></p>

                  <StatusBadge status={build.status || "Driven"} />

                  {build.lastUpdated && (
                    <p style={updatedStyle}>
                      Updated{" "}
                      {new Date(build.lastUpdated).toLocaleDateString()}
                    </p>
                  )}

                  <p style={detailsStyle}>{build.details}</p>

                  {getMatchedMods(build).length > 0 && (
                    <div style={matchedModsStyle}>
                      <strong>Matched Mods:</strong>

                      {getMatchedMods(build).map((mod) => (
                        <p key={mod.id} style={matchedModItemStyle}>
                          {mod.partName}
                          {mod.brand && ` — ${mod.brand}`}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>

        {filteredBuilds.length === 0 && !loading && (
          <p style={emptyStyle}>No builds found.</p>
        )}

        {hasMore && (
          <button
            onClick={() => loadBuilds(false)}
            disabled={loading}
            style={loadMoreButtonStyle}
          >
            {loading ? "Loading..." : "Load More Builds"}
          </button>
        )}
    </PageLayout>
  );
}


const inputStyle = {
  width: "100%",
  maxWidth: "500px",
  padding: "14px",
  borderRadius: "12px",
  border: "1px solid #2a2a2a",
  backgroundColor: "#1c1c1c",
  color: "white",
  marginBottom: "12px",
  display: "block",
  boxSizing: "border-box"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
  gap: "18px",
  marginTop: "24px"
};

const cardLinkStyle = {
  textDecoration: "none",
  color: "white"
};

const cardStyle = {
  backgroundColor: "#181818",
  border: "1px solid #242424",
  borderRadius: "18px",
  overflow: "hidden",
  transition: "0.2s ease"
};

const carImageStyle = {
  width: "100%",
  height: "190px",
  objectFit: "cover",
  display: "block"
};

const placeholderImageStyle = {
  height: "190px",
  backgroundColor: "#222",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "#777"
};

const cardContentStyle = {
  padding: "18px"
};

const titleStyle = {
  marginBottom: "8px"
};

const updatedStyle = {
  opacity: 0.6,
  fontSize: "13px",
  marginTop: "10px"
};

const detailsStyle = {
  opacity: 0.85,
  lineHeight: "1.6",
  marginTop: "14px"
};

const emptyStyle = {
  opacity: 0.7,
  marginTop: "30px"
};

const matchedModsStyle = {
  backgroundColor: "#1f1f1f",
  border: "1px solid #333",
  borderRadius: "12px",
  padding: "12px",
  marginTop: "14px"
};

const matchedModItemStyle = {
  margin: "6px 0 0",
  color: "#e10600",
  fontWeight: "bold"
};

const loadMoreButtonStyle = {
  marginTop: "30px",
  padding: "14px 18px",
  borderRadius: "12px",
  border: "none",
  backgroundColor: "#e10600",
  color: "white",
  fontWeight: "bold",
  cursor: "pointer"
};

export default Discover;
